var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#727B8E",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02294 12.004V12.085H10.4266V12.004C10.4472 10.9042 10.7706 10.4184 11.5963 9.92578C12.4702 9.39946 13 8.67746 13 7.59109C13 6.05263 11.8028 5 10.0138 5C8.37615 5 7.05505 5.93792 7 7.65857H8.48624C8.54817 6.65992 9.27064 6.21457 10.0138 6.21457C10.8394 6.21457 11.5 6.74764 11.5 7.59109C11.5 8.2996 11.0596 8.79892 10.4817 9.14305C9.57339 9.69636 9.04358 10.2362 9.02294 12.004ZM8.80275 14.0418C8.79587 14.5682 9.24312 14.9933 9.77982 15C10.3096 14.9933 10.75 14.5682 10.7569 14.0418C10.75 13.5155 10.3096 13.0837 9.77982 13.0837C9.24312 13.0837 8.79587 13.5155 8.80275 14.0418Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.ed7b51420b9d514f6c7e33c2e940ed28.svg";
export { ForwardRef as ReactComponent };